/* eslint-disable max-len */
export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*(\.[a-zA-Z0-9-]{2,})+$/;

export const getWordCount = (str) => {
    return str?.trim().split(/\s+/g).filter(Boolean).length;
};
